export const SET_HIGHLIGHTED_BOOKING_IDS =
  '@trybeapp/component/BookingCalendar/SET_HIGHLIGHTED_BOOKING_IDS'

export const SET_SELECTED_BLOCKED_TIME =
  '@trybeapp/component/BookingCalendar/SET_SELECTED_BLOCKED_TIME'
